import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { uploadServiceURL } from '../../../shared/apiUrlConfig';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class UploadService {
  // httpHeaderOptions = {
  //   headers: new Headers({
  //     'x-access-token': localStorage.getItem('Token'),
  //     'Cache-Control': 'no-cache',
  //     'Pragma': 'no-cache',
  //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
  //   })
  // };

  // httpHeaderOptions1 = {
  //   headers: new Headers({
  //     'Content-Type': 'multipart/form-data'
  //   })
  // };

  constructor(public httpClient: HttpClient, private http: Http, private userFriendlyMsgs: UserFriendlyMsgs) { }

  getSignedURL(body){
    // this.httpHeaderOptions = {
    //   headers: new Headers({
    //     'x-access-token': localStorage.getItem('Token'),
    //     'Cache-Control': 'no-cache',
    //     'Pragma': 'no-cache',
    //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    //   })
    // };
    //this.httpHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
    const uploadURL = `${environment.uploadServiceURL}`;
    return this.httpClient.post(uploadURL, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  uploadDocument(obj): Observable<any> {
    // this.httpHeaderOptions = {
    //   headers: new Headers({
    //     'x-access-token': localStorage.getItem('Token'),
    //     'Cache-Control': 'no-cache',
    //     'Pragma': 'no-cache',
    //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    //   })
    // };
    //this.httpHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
    const uploadURL = `${environment.uploadServiceURL}`;
    return this.httpClient.post(uploadURL, obj).catch(this.userFriendlyMsgs.errorHandler);
  }

  private handleError(error: Response | any) {
    
    return Observable.throw(error);
  }

  uploadDocumentWithSignedUrl(obj: File ,url:string): Observable<any> {
    // this.httpHeaderOptions1 = {
    //   headers: new Headers({
    //     'Content-Type': 'multipart/form-data'
    //   })
    // };
    const uploadURL = url;
    return this.httpClient.put(uploadURL, obj).catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/upload/upload.service.ts